import { getToken } from '@bettercomp/ams-spa-auth';
import { client } from 'connectors/ams/client.gen';
import { fetchWithRenewal } from 'service/amsFetch';
import { installDevAuthHeaders } from 'service/amsDevAuth';

/**
 * Wiring for the generated AMS public connector. Import SDK functions from
 * this module, never from `connectors/ams` directly — the raw client has no
 * base URL, bearer, or renew-on-401 fetch until this module configures them.
 *
 * The AMS public API is same-origin behind the app's CloudFront `/ams/*`
 * behavior. There is deliberately no 401→logout interceptor here: the
 * unauthenticated config fetch must never trigger a logout, and authenticated
 * calls get renew-then-retry from fetchWithRenewal with terminal outcomes
 * flowing to the auth gate through the session itself.
 */
client.setConfig({
  baseUrl: '/ams',
  auth: () => getToken() ?? undefined,
  fetch: fetchWithRenewal,
});

installDevAuthHeaders(client);

export * from 'connectors/ams/sdk.gen';
